module.exports = __webpack_public_path__ + "static/dt-9b675a09fbbcc2c32adc36d03deb1c58.jpg";